/*
 * Upsell block ("Protect Your Phone") on the product page:
 * products that have a variant per phone model (screen / camera lens protector)
 * get the variant for the model selected on the case and are added straight to cart.
 * - card shows "for <model>"
 * - if the selected model has no matching variant, the card is hidden
 * - products without model variants keep the theme's normal quick add
 */
(function () {
  if (window.__upsellModelInit) return;
  window.__upsellModelInit = true;

  // "Samsung Galaxy S25 5G" and "Samsung S25" -> "samsung s25" (same as product-bundle.js)
  function normModel(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\bgalaxy\b/g, '')
      .replace(/\b[45]g\b/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function money(cents) {
    if (typeof formatMoney === 'function' && window.theme && window.theme.settings) {
      return formatMoney(cents, window.theme.settings.money_with_currency_format);
    }
    return (cents / 100).toFixed(2);
  }

  function fetchProduct(url) {
    return fetch(url.replace(/[?#].*$/, '').replace(/\/$/, '') + '.js', { credentials: 'same-origin' }).then(
      function (r) {
        if (!r.ok) throw new Error('product ' + r.status);
        return r.json();
      }
    );
  }

  function aliasMap() {
    var map = {};
    var options = document.querySelector('bundle-options');
    if (options && options.aliases) {
      Object.keys(options.aliases).forEach(function (k) {
        map[k] = options.aliases[k];
      });
    }
    return map;
  }

  function init() {
    var blocks = document.querySelectorAll('.product__upsell');
    if (!blocks.length) return;
    var form = document.querySelector('form[id^="product-form-"]');
    var idInput = form && form.querySelector('[name="id"]');

    fetchProduct(location.pathname)
      .then(function (caseProduct) {
        var caseModels = {};
        caseProduct.variants.forEach(function (v) {
          caseModels[normModel(v.title)] = true;
        });
        var current = caseProduct.variants.find(function (v) {
          return idInput && String(v.id) === String(idInput.value);
        });
        var state = { model: current ? current.title : caseProduct.variants[0] && caseProduct.variants[0].title };

        var cards = [];
        blocks.forEach(function (block) {
          block.querySelectorAll('.product-card-sm').forEach(function (card) {
            var trigger = card.querySelector('quick-view[data-product-url]');
            if (!trigger) return; // single-variant product: theme form already works
            cards.push({ block: block, card: card, trigger: trigger, product: null });
          });
        });
        if (!cards.length) return;

        Promise.all(
          cards.map(function (entry) {
            return fetchProduct(entry.trigger.dataset.productUrl)
              .then(function (p) {
                // model product = at least one variant title is a phone model of this case
                var isModel = p.variants.some(function (v) {
                  return caseModels[normModel(v.title)];
                });
                if (isModel) entry.product = p;
              })
              .catch(function () {});
          })
        ).then(function () {
          cards = cards.filter(function (e) {
            return e.product;
          });
          cards.forEach(setupCard);
          apply();
        });

        function matchVariant(product) {
          var aliases = aliasMap();
          var target = normModel(state.model);
          if (aliases[target]) target = aliases[target];
          return (
            product.variants.find(function (v) {
              return v.available && normModel(v.title) === target;
            }) || null
          );
        }

        function setupCard(entry) {
          var info = entry.card.querySelector('.product-card-sm__info');
          entry.note = document.createElement('div');
          entry.note.className = 'product-card-sm__model text-size-small';
          entry.note.style.opacity = '0.7';
          if (info) info.insertBefore(entry.note, info.querySelector('.product-card-sm__info__price'));
          entry.price = entry.card.querySelector('.product-card-sm__info__price');

          // Capture phase: runs before the theme's quick-view click handler
          entry.trigger.addEventListener(
            'click',
            function (event) {
              if (!entry.variant) return;
              event.preventDefault();
              event.stopImmediatePropagation();
              addToCart(entry);
            },
            true
          );
          entry.trigger.addEventListener(
            'keydown',
            function (event) {
              if (!entry.variant || (event.key !== 'Enter' && event.key !== ' ')) return;
              event.preventDefault();
              event.stopImmediatePropagation();
              addToCart(entry);
            },
            true
          );
        }

        function apply() {
          cards.forEach(function (entry) {
            entry.variant = matchVariant(entry.product);
            entry.card.hidden = !entry.variant;
            entry.card.style.display = entry.variant ? '' : 'none';
            if (entry.variant) {
              entry.note.textContent = (window.upsellModelLabel || 'for [model]').replace('[model]', entry.variant.title);
            }
          });
          // hide a block whose cards are all hidden
          blocks.forEach(function (block) {
            var visible = Array.prototype.some.call(block.querySelectorAll('.product-card-sm'), function (card) {
              return card.style.display !== 'none';
            });
            block.style.display = visible ? '' : 'none';
          });
        }

        function addToCart(entry) {
          if (entry.busy) return;
          entry.busy = true;
          entry.trigger.classList.add('loading');
          var spinner = entry.trigger.querySelector('.loading__spinner');
          if (spinner) spinner.classList.remove('hidden');
          fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: entry.variant.id, quantity: 1, properties: { _source: 'product-upsell' } }] }),
          })
            .then(function (r) {
              return r.json().then(function (data) {
                if (!r.ok || data.status) throw new Error(data.description || data.message || 'Error');
                return data;
              });
            })
            .then(function () {
              refreshCart();
            })
            .catch(function (error) {
              window.alert(error.message);
            })
            .finally(function () {
              entry.busy = false;
              entry.trigger.classList.remove('loading');
              if (spinner) spinner.classList.add('hidden');
            });
        }

        function refreshCart() {
          var api = window.kachingCartApi;
          if (api && typeof api.refreshCart === 'function') {
            Promise.resolve(api.refreshCart()).then(function () {
              if (typeof api.openCart === 'function') api.openCart();
            });
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'upsell-model' });
          }
        }

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
            var variant = event && event.data && event.data.variant;
            if (variant && variant.title) {
              state.model = variant.title;
              apply();
            }
          });
        }
      })
      .catch(function (e) {
        console.warn('upsell model', e);
      });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
